
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLightRain as ObiLightRainElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-light-rain.js';
 
 
 

 
 export const ObiLightRain = createComponent({
   react: React,
   tagName: 'obi-light-rain',
   elementClass: ObiLightRainElement,
   events: {
     
   }
  });
 
 